export const CarDocsIcon = ({ className }) => {
  return (
    <svg
      width={80}
      height={80}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_9743_4202)">
        <path
          d="M62.5 70H17.5C16.837 70 16.2011 69.7366 15.7322 69.2678C15.2634 68.7989 15 68.163 15 67.5V12.5C15 11.837 15.2634 11.2011 15.7322 10.7322C16.2011 10.2634 16.837 10 17.5 10H47.5L65 27.5V67.5C65 68.163 64.7366 68.7989 64.2678 69.2678C63.7989 69.7366 63.163 70 62.5 70Z"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.5 10V27.5H65"
          stroke="#A5A5A5"
          strokeWidth={5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M53.3332 49.5631V53.6668C53.3332 54.288 53.3332 54.5987 53.2317 54.8438C53.0964 55.1704 52.8368 55.43 52.5101 55.5654C52.265 55.6668 51.9544 55.6668 51.3332 55.6668C50.712 55.6668 50.4013 55.6668 50.1562 55.5654C49.8296 55.43 49.57 55.1704 49.4346 54.8438C49.3332 54.5987 49.3332 54.288 49.3332 53.6668C49.3332 53.0456 49.3332 52.735 49.2317 52.4899C49.0964 52.1632 48.8368 51.9036 48.5101 51.7683C48.265 51.6668 47.9544 51.6668 47.3332 51.6668H32.6665C32.0453 51.6668 31.7346 51.6668 31.4896 51.7683C31.1629 51.9036 30.9033 52.1632 30.768 52.4899C30.6665 52.735 30.6665 53.0456 30.6665 53.6668C30.6665 54.288 30.6665 54.5987 30.565 54.8438C30.4297 55.1704 30.1701 55.43 29.8434 55.5654C29.5984 55.6668 29.2878 55.6668 28.6665 55.6668C28.0453 55.6668 27.7346 55.6668 27.4896 55.5654C27.1629 55.43 26.9033 55.1704 26.768 54.8438C26.6665 54.5987 26.6665 54.288 26.6665 53.6668V49.5631C26.6665 47.9602 26.6665 47.1586 26.8953 46.4028C27.1242 45.647 27.5688 44.98 28.458 43.6463L29.3332 42.3335L30.6152 39.2566C31.6095 36.8703 32.1067 35.6771 33.1144 35.0053C34.1221 34.3335 35.4147 34.3335 37.9998 34.3335H41.9998C44.585 34.3335 45.8776 34.3335 46.8853 35.0053C47.893 35.6771 48.3901 36.8703 49.3845 39.2566L50.6665 42.3335L51.5417 43.6463C52.4309 44.98 52.8754 45.647 53.1044 46.4028C53.3332 47.1586 53.3332 47.9602 53.3332 49.5631Z"
          stroke="#A5A5A5"
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.6665 40.3335L29.3332 42.3335L31.9998 43.0002H47.9998L50.6665 42.3335L53.3332 40.3335"
          stroke="#A5A5A5"
          strokeWidth={4}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9743_4202">
          <rect width={80} height={80} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
